import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#4BB7C0",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#FEC50C",
      fillRule: "evenodd",
      d: "M12.25 17.823c.445.56 1.123 1.418 2.169 2.17 1.02.733 3.19 1.288 4.639 1.506l-.067.074c-.32.36-.641.72-1.119.872-.11.055-.233.096-.356.137-.252.084-.507.17-.67.382a.3.3 0 0 0-.025.132.2.2 0 0 0-.016.045l-.018.01c-.099.057-.201.116-.26.215a.35.35 0 0 0-.052.167l-.001.004a.5.5 0 0 0 .046.223c.005.009.01-.004.016-.023.009-.023.021-.056.041-.063a.6.6 0 0 1 .214-.107c.065-.033.056.002.03.053l-.006.019c-.01.037-.029.1.012.058.216-.096.456-.115.69-.133.34-.035.714-.068 1.065.03.864.08 1.59-.154 1.612-.176.012-.085-.259-.076-.604-.064-.362.012-.806.027-1.09-.062-.622-.194.164-.742.375-.89l.005-.003.044-.038a3.7 3.7 0 0 1 1.27-.742c.313-.103.654-.205.997-.308.701-.21 1.417-.425 1.945-.666 1.335-.612 2.318-1.694 2.963-2.404.522-.575.822-.905.908-.543.125.515-.522 1.5-1.454 2.6-.914 1.079-2.247 1.925-2.558 1.956.785.06 1.594-.085 2.265-.512a.7.7 0 0 1 .182-.11c.142-.07.28-.138.111-.195l-.115-.041c-.126-.042-.274-.09-.287-.16.213-.132.46-.159.706-.185.172-.019.345-.038.506-.093.007-.089-.144-.098-.274-.105a1 1 0 0 1-.138-.015c-.273-.022-.257-.092.006-.118a5 5 0 0 1 .274-.06c.254-.052.512-.103.718-.263-.12-.055-.256-.056-.394-.057-.124 0-.25-.001-.365-.042.161-.07.334-.116.506-.162.27-.072.539-.143.765-.308.145-.162-.121-.141-.269-.13l-.06.005c-.229.04-.334-.07-.074-.165.137-.101.287-.192.436-.283.332-.201.666-.404.881-.731.074-.106.174-.426-.061-.311-.108.035-.21.1-.314.166-.195.123-.391.248-.622.177.696-.539 1.357-1.152 1.833-1.898.024-.215-.313-.239-.401-.07q-.152.148-.302.303c-.338.347-.68.698-1.121.906.547-.529 1-1.155 1.396-1.804q.035-.075.086-.157c.093-.155.194-.324.102-.482-.199-.165-.448-.014-.552.183a9 9 0 0 0-.313.446c-.22.326-.439.654-.744.906.39-.746.796-1.54.806-2.402-.002-.177-.037-.438-.278-.405-.125.023-.148.152-.172.28a.7.7 0 0 1-.052.184q-.065.226-.12.457c-.112.448-.225.9-.49 1.283q.023-.133.05-.27c.074-.393.15-.796.063-1.188-.05-.216-.399-.123-.354.09-.416 2.108-1.83 3.951-3.68 5.017a7.9 7.9 0 0 1-2.755.928 2 2 0 0 1-.335.04 1.7 1.7 0 0 0-.453.073l-.1-.007c-1.408-.083-3.566-.592-4.727-1.388-1.41-.973-2.492-2.424-2.975-4.072-.039-.113-.064-.234-.089-.354a2.3 2.3 0 0 0-.107-.398c-.115-.094-.292-.047-.31.11-.069.403.008.811.084 1.211l.04.216c-.276-.408-.393-.885-.51-1.36q-.061-.259-.134-.513a.5.5 0 0 1-.04-.128c-.024-.11-.05-.223-.183-.202-.223-.007-.236.239-.245.405v.007c.01.849.41 1.626.791 2.365l.015.03c-.297-.251-.514-.572-.73-.892-.114-.168-.227-.335-.352-.492-.094-.159-.277-.285-.462-.192-.185.065-.082.285-.02.407.345.675.814 1.28 1.308 1.853a.7.7 0 0 0 .136.132c.07.06.12.102.013.05-.406-.214-.726-.543-1.045-.87q-.15-.157-.306-.307c-.087-.163-.418-.131-.391.079.393.63.938 1.153 1.498 1.634.029.041.093.084.154.126.087.059.168.114.138.154-.217.035-.395-.076-.574-.187-.137-.085-.274-.171-.43-.192-.115.025.009.213.068.303l.013.02c.416.443.984.689 1.536.928l.18.078c-.147.063-.308.048-.467.033a2 2 0 0 0-.208-.014c-.03.009-.087 0-.145-.008-.11-.016-.225-.033-.176.059.204.23.492.268.781.306.174.024.348.047.505.111-.095.08-.223.101-.342.121l-.029.005c-.037.016-.094.02-.153.026-.1.009-.201.018-.211.08.154.105.337.128.52.151.1.013.2.025.294.051.267.017.15.072-.04.117a1 1 0 0 1-.122.035c-.087.02-.176.042-.208.098.243.152.532.2.815.247q.123.02.243.043c-.077.034-.158.057-.239.08a1.5 1.5 0 0 0-.289.102c.377.14.748.295 1.116.457.71.316 1.464.546 2.244.591-.269-.05-2.179-1.5-3.245-2.621s-1.162-2.359-.886-2.37c.125-.08.325.174.657.593m10.453 6.093c.04-.094.078-.185.152-.225.059.022.116.06.174.1.132.088.267.178.428.081.103-.075.117-.204.131-.328q.007-.065.018-.126c-.027-.16.037-.109.126-.036.071.058.159.13.23.119.339.117.76-.15.7-.528a13 13 0 0 1-.949-.08c-.459-.05-.917-.099-1.379-.079-.019.002-.038.042-.067.103-.076.157-.218.454-.6.584-.58.196-1.478.246-2.111.281-.24.014-.442.025-.574.041-.467.04-1.021.218-1.154.726.266.071.499-.09.717-.242q.091-.065.18-.12c.036.02.03.089.024.168-.009.101-.018.219.053.277.225-.018.381-.229.517-.412l.069-.092c.066.075.049.17.032.264-.016.089-.032.175.026.24.197.018.32-.126.44-.269.066-.077.131-.153.207-.204.074-.012.058.07.038.167-.019.094-.04.202.016.248.21.089.425-.06.492-.263.098-.286.189-.074.226.106.122.204.357.012.446-.123.082-.21.162-.121.258-.015.03.033.063.069.097.097.203.032.312-.12.418-.27a1 1 0 0 1 .16-.192c-.014.173.175.398.33.223a.6.6 0 0 0 .129-.22",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M3.334 5.333a.667.667 0 1 0 1.333 0 .667.667 0 0 0-1.333 0m.888 0a.222.222 0 1 1-.444 0 .222.222 0 0 1 .444 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M4.667 5.333a.667.667 0 1 0 1.333 0 .667.667 0 0 0-1.333 0m.889 0a.222.222 0 1 1-.445 0 .222.222 0 0 1 .445 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M5.334 4.333a.333.333 0 1 1 .666 0v1l-.667-.266zM3.334 6a.667.667 0 1 0 1.333 0 .667.667 0 0 0-1.333 0m.888 0a.222.222 0 1 1-.444 0 .222.222 0 0 1 .444 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M4.667 6A.667.667 0 1 0 6 6a.667.667 0 0 0-1.333 0m.889 0a.222.222 0 1 1-.445 0 .222.222 0 0 1 .445 0M3.334 4.333a.333.333 0 1 1 .666 0v.734l-.667.266zm0 2.334L4 6.933v.734a.333.333 0 0 1-.667 0zm2 .266L6 6.667v1a.333.333 0 0 1-.667 0zm-2 7.734a.667.667 0 1 0 1.333 0 .667.667 0 0 0-1.333 0m.888 0a.222.222 0 1 1-.444 0 .222.222 0 0 1 .444 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M4.667 14.667a.667.667 0 1 0 1.333 0 .667.667 0 0 0-1.333 0m.889 0a.222.222 0 1 1-.445 0 .222.222 0 0 1 .445 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M5.334 14.333a.333.333 0 1 1 .666 0v1l-.667-.266zm-2 1.667a.667.667 0 1 0 1.333 0 .667.667 0 0 0-1.333 0m.888 0a.222.222 0 1 1-.444 0 .222.222 0 0 1 .444 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M4.667 16A.667.667 0 1 0 6 16a.667.667 0 0 0-1.333 0m.889 0a.222.222 0 1 1-.445 0 .222.222 0 0 1 .445 0m-2.222-1.667a.333.333 0 1 1 .666 0v.734l-.667.266zm0 1.667.666.267V17a.333.333 0 0 1-.667 0z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M5.334 16.267 6 16v1a.333.333 0 0 1-.667 0z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M4.248 6.813c-.608 1.423-.915 2.5-.915 3.252 0 .816.271 1.332.696 1.262.368-.06.638-.574.638-1.19v-.44c0-.153-.1-.277-.222-.277-.123 0-.223.124-.223.276v.44c0 .367-.135.624-.251.644-.088.014-.193-.186-.193-.715 0-.639.286-1.643.863-2.993.057-.134.016-.301-.092-.373-.109-.072-.243-.02-.3.114"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M5.085 6.813c.609 1.423.915 2.5.915 3.252 0 .816-.27 1.332-.695 1.262-.369-.06-.638-.574-.638-1.19v-.44c0-.153.1-.277.222-.277.123 0 .222.124.222.276v.44c0 .367.136.624.252.644.088.014.193-.186.193-.715 0-.639-.286-1.643-.863-2.993-.058-.134-.016-.301.092-.373s.243-.02.3.114m-.837 8.374c-.608-1.423-.915-2.5-.915-3.252 0-.816.271-1.332.696-1.262.368.06.638.574.638 1.19v.44c0 .153-.1.277-.222.277-.123 0-.223-.124-.223-.276v-.44c0-.367-.135-.624-.251-.644-.088-.014-.193.186-.193.715 0 .639.286 1.643.863 2.993.057.134.016.301-.092.373-.109.072-.243.02-.3-.114"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M5.085 15.187c.609-1.423.915-2.5.915-3.252 0-.816-.27-1.332-.695-1.262-.369.06-.638.574-.638 1.19v.44c0 .153.1.277.222.277.123 0 .222-.124.222-.276v-.44c0-.367.136-.624.252-.644.088-.014.193.186.193.715 0 .639-.286 1.643-.863 2.993-.058.134-.016.301.092.373s.243.02.3-.114"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M3.334 24.667a.667.667 0 1 0 1.333 0 .667.667 0 0 0-1.333 0m.888 0a.222.222 0 1 1-.444 0 .222.222 0 0 1 .444 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M4.667 24.667a.667.667 0 1 0 1.333 0 .667.667 0 0 0-1.333 0m.889 0a.222.222 0 1 1-.445 0 .222.222 0 0 1 .445 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M5.334 23.667a.333.333 0 1 1 .666 0v1l-.667-.267zm-2 2.333a.667.667 0 1 0 1.333 0 .667.667 0 0 0-1.333 0m.888 0a.222.222 0 1 1-.444 0 .222.222 0 0 1 .444 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M4.667 26A.667.667 0 1 0 6 26a.667.667 0 0 0-1.333 0m.889 0a.222.222 0 1 1-.445 0 .222.222 0 0 1 .445 0m-2.222-2.333a.333.333 0 1 1 .666 0v.733l-.667.267zm0 2.333.666.267V27a.333.333 0 0 1-.667 0z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M5.334 26.267 6 26v1a.333.333 0 0 1-.667 0z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M4.248 16.813c-.608 1.423-.915 2.5-.915 3.252 0 .816.271 1.332.696 1.262.368-.06.638-.574.638-1.19v-.44c0-.153-.1-.277-.222-.277-.123 0-.223.124-.223.276v.44c0 .367-.135.624-.251.643-.088.015-.193-.185-.193-.714 0-.639.286-1.643.863-2.993.057-.134.016-.302-.092-.373-.109-.072-.243-.02-.3.114"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M5.085 16.813c.609 1.423.915 2.5.915 3.252 0 .816-.27 1.332-.695 1.262-.369-.06-.638-.574-.638-1.19v-.44c0-.153.1-.277.222-.277.123 0 .222.124.222.276v.44c0 .367.136.624.252.643.088.015.193-.185.193-.714 0-.639-.286-1.643-.863-2.993-.058-.134-.016-.302.092-.373s.243-.02.3.114m-.837 7.707c-.608-1.423-.915-2.5-.915-3.251 0-.817.271-1.332.696-1.263.368.06.638.574.638 1.19v.441c0 .153-.1.276-.222.276-.123 0-.223-.123-.223-.276v-.44c0-.366-.135-.624-.251-.643-.088-.015-.193.185-.193.715 0 .638.286 1.643.863 2.992.057.135.016.302-.092.373-.109.072-.243.02-.3-.114"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M5.085 24.52c.609-1.423.915-2.5.915-3.251 0-.817-.27-1.332-.695-1.263-.369.06-.638.574-.638 1.19v.441c0 .153.1.276.222.276.123 0 .222-.123.222-.276v-.44c0-.366.136-.624.252-.643.088-.015.193.185.193.715 0 .638-.286 1.643-.863 2.992-.058.135-.016.302.092.373s.243.02.3-.114"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M19.334 17.333a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M18.99 17.988a4.7 4.7 0 0 1-1.12-.222l.293 1.452zm.687 0a4.7 4.7 0 0 0 1.12-.222l-.293 1.452zm1.755-.485 1.235.82-.285-1.456a4.7 4.7 0 0 1-.95.636m1.435-1.121 1.455.285-.82-1.235a4.7 4.7 0 0 1-.635.95m.899-1.585 1.452-.293-1.23-.828a4.7 4.7 0 0 1-.222 1.121m.222-1.807 1.23-.827-1.452-.294q.178.537.222 1.121m-.485-1.755.82-1.235-1.456.285q.375.434.636.95M22.382 9.8l.285-1.456-1.235.82q.516.261.95.636m-1.585-.9-.293-1.451-.828 1.23q.586.043 1.121.222m-1.807-.22-.827-1.231-.294 1.452a4.7 4.7 0 0 1 1.121-.222m-1.755.484L16 8.344l.285 1.456q.434-.375.95-.636m-1.435 1.12L14.345 10l.82 1.235q.26-.516.635-.95m-.899 1.585-1.452.294 1.23.827q.043-.585.222-1.12m-.222 1.807-1.23.828 1.452.293a4.6 4.6 0 0 1-.222-1.12m.485 1.756-.82 1.235 1.456-.285a4.7 4.7 0 0 1-.636-.95m1.121 1.435L16 18.322l1.235-.82a4.7 4.7 0 0 1-.95-.635",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagKaz = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagKaz_default = SvgFlagKaz;

export { FlagKaz_default as default };
